import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { CubicMeter, CubicFeet, HundredCubicFeet, Liter, Gallon, } from "./volume";
import { Hour, Minute } from "./duration";
// VolumeFlow
export var CubicMeterPerSecond = UnitDivide.volumeByDuration("CubicMeterPerSecond", CubicMeter, BaseUnits.Second);
export var CubicMeterPerHour = UnitDivide.volumeByDuration("CubicMeterPerHour", CubicMeter, Hour);
export var CubicFeetPerMinute = UnitDivide.volumeByDuration("CubicFeetPerMinute", CubicFeet, Minute);
export var CubicFeetPerHour = UnitDivide.volumeByDuration("CubicFeetPerHour", CubicFeet, Hour);
export var HundredCubicFeetPerHour = UnitDivide.volumeByDuration("HundredCubicFeetPerHour", HundredCubicFeet, Hour);
export var LiterPerSecond = UnitDivide.volumeByDuration("LiterPerSecond", Liter, BaseUnits.Second);
export var LiterPerMinute = UnitDivide.volumeByDuration("LiterPerMinute", Liter, Minute);
export var LiterPerHour = UnitDivide.volumeByDuration("LiterPerHour", Liter, Hour);
export var GallonsPerMinute = UnitDivide.volumeByDuration("GallonsPerMinute", Gallon, Minute);
export var GallonsPerHour = UnitDivide.volumeByDuration("GallonsPerHour", Gallon, Hour);
//# sourceMappingURL=volume-flow.js.map